import { gql } from 'urql';

const PayOverTimeStatements = gql`
  query PayOverTimeStatements {
    payOverTimeStatements {
      __typename
      ... on PayOverTimeListStatementsSuccess {
        statements {
          id
          fileName
          fileSize
          createdAt
        }
      }
      ... on PayOverTimeListStatementsError {
        code
        title
        message
      }
    }
  }
`;

export default PayOverTimeStatements;
